<template>
  <div id="loader-spacer">
    <div id="loader-container">
      <div id="loader"></div>
      <h2>Loading Data…</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>

<style lang="scss">
#loader-container {
  width: 100%;
  height: calc(100vh - 280px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;
  #loader {
      display: inline-block;
      width: 170.5px;
      height: 179px;
      background-image: url(../assets/img/loader-unsung-condensed-copy.png);
      background-size: 1200px 179px;
      animation: sprite-cycle 1s steps(7) infinite;
  }
}
@keyframes sprite-cycle {
  0% {
    background-position-x: 0px;
  }

  100% {
    background-position-x: 1200px;
  }
}
</style>